var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resources-folder-grid"},_vm._l((this.files),function(file){return _c('ResourcesFolderCard',{key:file.id,attrs:{"id":file.id,"description":file.description,"file-count":file.count,"image":file.thumbnail,"title":file.name,"organizationId":_vm.organizationId}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }